import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import { CreateSkuTransactionParams, SkuTransaction } from "@chipi-stack/types";

type CreateSkuTransactionInput = { 
    params: CreateSkuTransactionParams; 
    bearerToken: string; 
};

/**
 * Hook for creating SKU transactions
 */
export function useCreateSkuTransaction(): {
    createSkuTransaction: (input: CreateSkuTransactionInput) => void;
    createSkuTransactionAsync: (input: CreateSkuTransactionInput) => Promise<SkuTransaction>;
    data: SkuTransaction | undefined;
    isLoading: boolean;
    isError: boolean;
    error: Error | null;
    isSuccess: boolean;
    reset: () => void;
} {
    const { chipiSDK } = useChipiContext();

    const mutation: UseMutationResult<SkuTransaction, Error, CreateSkuTransactionInput> = useMutation({
        mutationFn: (input: CreateSkuTransactionInput) =>
            chipiSDK.createSkuTransaction({
                params: input.params,
                bearerToken: input.bearerToken,
            }),
    });

    return {
        createSkuTransaction: mutation.mutate,
        createSkuTransactionAsync: mutation.mutateAsync,
        data: mutation.data,
        isLoading: mutation.isPending,
        isError: mutation.isError,
        error: mutation.error,
        isSuccess: mutation.isSuccess,
        reset: mutation.reset,
    };
}